import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { copyLinkToClipboard } from 'helpers/utils'
import { ReplyIcon } from './'

const CopyLink = ({ link, children, className }) => {
  const handleProfileLinkCopy = useCallback(() => {
    const url = `${window.location.origin}${link}`
    copyLinkToClipboard(url)
  }, [link])

  return (
    <button
      className={classnames('flex items-center bg-transparent w-max', className)}
      onClick={handleProfileLinkCopy}
    >
      <span className="text-base mr-2">{children}</span>
      <ReplyIcon className="w-3.5" />
    </button>
  )
}

CopyLink.propTypes = {
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
}

CopyLink.defaultProps = {
  classNames: {},
}

export default CopyLink
